<template>
  <div class="xh-wrap">
    <div class="container text-center">
      <img
        class="logo md-hidden"
        src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/media_logo_pc.png"
      />
      <img
        class="logo  lg-hidden md-visible"
        src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/media_logo_mb.png"
      />

      <div class="en_wrap fs-20 flex_wrap" v-if="_i18n.locale==='en'">
        <span>Dear Journalists,</span>
        <span>Auto Guangzhou 2025 will take place at China Import and Export Fair Complex (Canton Fair Complex) from November 21st to November 30th. The media registration system is now live. Journalists are welcome to log in to the Auto Guangzhou official website: www.autoguangzhou.com.cn.</span>
        <span>Attention：</span>
        <span>1. Journalists must register using their real names. Please use your passport, Hong Kong/Macao Special Administrative Region Travel Permit, or Mainland Travel Permit for Taiwan Residents, along with your e-mail address, for registration. Ensure all information is accurate and upload the required documents.</span>
        <span>2. On-site collection of physical media badges is available (Location: Media Accreditation Office, South Registration Hall, Area D, China Import and Export Fair Complex). However, these badges are for security check purposes only and do not guarantee final admission. Entry will be denied to anyone presenting a physical media badge without the accompanying E-Badge.</span>
        <span>3. All journalists must enter the exhibition with valid verification. The organizers reserve the right to refuse entry if the presented identification does not match the registered individual, or if there are inconsistencies with the media registration information.</span>
        <span>On-site Registration:</span>
        <span>1.  Registration must be completed in person and cannot be processed by a third party.</span>
        <span>2. On-site applications are restricted to domestic journalists and overseas journalists residing in China or dispatched by foreign news agencies who hold press cards issued by the Ministry of Foreign Affairs of the People’s Republic of China.</span>
        <span>Location: Media Accreditation Office, South Registration Hall, Area D, China Import and Export Fair Complex</span>
        <span>On-site Registration Time</span>
        <span>November 19th, 2025 10:00-17:00</span>
        <span>November 20th, 2025 10:00-18:00</span>
        <span>November 21st, 2025 08:00-17:00</span>
        <span>Please Note:</span>
        <span>1. Physical media badges must be picked up in person by the accredited journalist and cannot be collected by others.</span>
        <span>2. Please fill out the registration information carefully, as it cannot be modified after being reviewed and approved by the organizer.</span>
      </div>
      <img
        class="qrcode"
        :src="_i18n.locale=='en'?'https://faststatic.ccnfgame.com/cos/vrshow/autoShow/media_qr_en.png':'https://faststatic.ccnfgame.com/cos/vrshow/autoShow/page_media_1.png'"
      />
      <div class="color-fff fs-20 mt-20" v-if="_i18n.locale=='zh'">关注“广州车展媒体之窗”微信公众号,</div>
      <div class="color-fff fs-20 mt-20">
        {{ $t('mediacenter.applytips1') }}
      </div>
      <div class="passport_other">
        <span
          class="clickable"
          role="button"
          tabindex="0"
          @click="tomedia"
          @keydown.enter="tomedia"
          @keydown.space.prevent="tomedia"
        >{{ $t('mediacenter.applytips2') }}</span>
      </div>
      <!-- <div class="passport_other media_tips"> -->
        <!-- <span>{{ $t('mediacenter.followOfficialAccount') }}</span>  -->
        <!-- <span>Reporters from other countries and areas please click here</span> -->
      <!-- </div> -->
      <footer class="fs-20 color-fff">
        {{ $t('pagebottom.copyright') }}
        <a
          class="color-fff"
          target="_blank"
          href="http://www.beian.miit.gov.cn/"
          >粤ICP备17092841号-4</a
        >
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    console.log(this._i18n.locale);
  },
  methods: {
    tomedia(){
      // this.$router.push({path:'/foreignMediaMain'})
      window.location.href = 'https://vrhall.ccnfgame.com/wapp/chat/#/pages/mediaguangzhou/foreignMediaMain'
    }
  },
};
</script>

<style scoped lang="scss">
img {
  display: block;
  margin: 0 auto;
}

footer {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  line-height: 60px;
  width: 100%;
  background-color: #419ffc;
}
@media screen and (min-width: 100px) and (max-width: 1000px) {
  footer {
    height: 180px;
    line-height: 180px;
  }
  .xh-wrap {
    padding-top: 400px;
  }
  .md-hidden {
    display: none;
  }
  .md-visible {
    display: block;
  }
  .mt-190 {
    margin-top: 300px;
  }
  .logo {
    width: 70%;
  }
  .qrcode {
    width: 70%;
    margin-bottom: 120px;
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
  .lg-hidden {
    display: none;
  }
  .xh-wrap {
    padding-top: 100px;
  }
  .mt-190 {
    margin-top: 100px;
  }
  .logo {
    width: 731px;
  }
  .qrcode {
    width: 360px;
    margin-top:50px;
  }
  .passport_other{
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    color: #fff;
    cursor: pointer;
    margin-bottom: 200px;
    >span{
      font-size: 20px;
      
    }
  

  }
  /* Clickable effect for apply tip */
  .passport_other > span.clickable {
    text-decoration: underline;
    transition: color 0.2s ease, opacity 0.2s ease;
  }
  .passport_other > span.clickable:hover {
    color: #419ffc;
  }
  .passport_other > span.clickable:active {
    opacity: 0.8;
  }
    .media_tips{
  color: #fff;
  cursor: pointer;
  margin-top: 220px;
}
.en_wrap{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #fff;
  text-align: left;
  line-height: 40px;
}
  .passport_other:hover{
    color: #419ffc;
  }
}
</style>



// WEBPACK FOOTER //
// mediaApply.vue?ab54ffa0